import { useNavigate } from 'react-router';

import { CampaignSelector } from '@/components/features/CampaignSelector';
import { useCampaignSelection } from '@/entities/campaign';

import { VoiceHistoryContent } from './VoiceHistoryContent';
import { ChatHistoryContent } from './ChatHistoryContent';

export function HistoryPage() {
  const navigate = useNavigate();
  const { campaignId, setCampaignId, campaigns, campaignsLoading, selectedCampaign } = useCampaignSelection();

  const isText = selectedCampaign?.telephony === 'custom';
  const isReady = !!campaignId && !campaignsLoading;

  const handleCampaignChange = (id: number | null) => {
    setCampaignId(id);
    // Reset detail selection when switching campaigns
    navigate('/history', { replace: true });
  }

  return (
    <div className="w-full h-full p-6 overflow-y-auto">
      <div className="mb-4 grid gap-4">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          <div className="flex-shrink-0 grid gap-1">
            <h1 className="text-heading font-bold">Conversations</h1>
            <p className="text-detail text-muted-foreground">
              {isText
                ? 'Browse and analyze chat conversations. Click a row to see details.'
                : 'Browse and analyze calls. Click a row to see call details.'}
            </p>
          </div>
          <CampaignSelector
            campaigns={campaigns}
            selectedCampaignId={campaignId}
            onCampaignChange={handleCampaignChange}
            className="w-full sm:w-80 lg:w-96"
            disabled={campaignsLoading}
          />
        </div>
      </div>

      {!isReady ? (
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">Select a campaign to view conversations</div>
        </div>
      ) : isText ? (
        <ChatHistoryContent campaignId={campaignId} />
      ) : (
        <VoiceHistoryContent campaignId={campaignId} />
      )}
    </div>
  )
}
